import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getOrganizationBasicCoursesQuery,
  getBulkUploadTemplateURLQuery,
  getCourseCount,
  getStaffCount,
  getStudentCount,
} from "SchoolSetup/modules/Queries";
export const getOrganizationBasicCoursesFromCache = ({
  filters,
  organizationId,
}) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationBasicCoursesQuery,
      variables: { filters, organizationId },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getTemplateUrl = async ({
  organizationId,
  type,
  curriculumProgramId,
  academicYearId,
  filters,
}) => {
  const response = await client.query({
    query: getBulkUploadTemplateURLQuery,
    variables: {
      organizationId,
      type,
      curriculumProgramId,
      academicYearId,
      filters,
    },
    fetchPolicy: "network-only",
  });
  const data = await _.get(
    response,
    "data.node.organizationDataBulkDownload",
    []
  );
  return data;
};

export const getUserCount = async ({
  type,
  filters,
  organizationId,
  curriculumProgramId,
  academicYearId,
}) => {
  let query;
  let updatedFilters = {};
  switch (type) {
    case "COURSE":
      query = getCourseCount;
      updatedFilters = {
        ...filters,
        curriculumProgramIds: curriculumProgramId ? [curriculumProgramId] : [],
        academicYears: [academicYearId],
      };
      break;
    case "STAFF":
      query = getStaffCount;
      updatedFilters = {
        ...filters,
        curriculumProgramIds: curriculumProgramId ? [curriculumProgramId] : [],
        academicYearIds: [academicYearId],
      };
      break;
    case "STUDENT":
      query = getStudentCount;
      updatedFilters = {
        ...filters,
        curriculumProgramIds: curriculumProgramId ? [curriculumProgramId] : [],
        academicYearId,
      };
      break;
    case "CLASS_SETTINGS":
      query = getStudentCount;
      updatedFilters = {
        ...filters,
        academicYearId,
      };
      break;
  }

  try {
    const response = await client.query({
      query,
      variables: {
        organizationId,
        filters: updatedFilters,
      },
      fetchPolicy: "network-only",
    });

    switch (type) {
      case "COURSE":
        return _.get(response, "data.node.courses.totalCount", 0);
      case "STAFF": {
        const userCount = _.get(response, "data.node.staff.userCount", []);
        const users = ["admin", "teacher"];
        let count = 0;

        _.forEach(userCount, ({ role, totalCount }) => {
          if (_.includes(users, role)) count += totalCount;
        });
        return count;
      }
      case "STUDENT":
      case "CLASS_SETTINGS":
        return _.get(response, "data.node.students.totalCount", 0);
    }
  } catch (e) {
    return 0;
  }
};
